<template>
	<div id="model" v-loading="loading" class="gcardfr">
		<el-row :gutter="0" class>
			<el-col :span="16">
				<el-button size="small" type="primary" icon="el-icon-plus" @click="addMd">{{ $t('model.add_model') }}</el-button>
			</el-col>
		</el-row>
		<el-table ref="multipleTable" class="gtbtop" tooltip-effect="dark" :data="tableData" style="width: 100%">
			<el-table-column prop="productname" :label="$t('model.app_model')" width></el-table-column>
			<el-table-column prop="productkey" label="productKey" width></el-table-column>
			<el-table-column prop="created" :label="$t('app_add_time')" width="190"></el-table-column>	
			<el-table-column prop="name" :label="$t('app_operation')" width="130">
				<template slot-scope="scope">
					<el-button type="text" @click="editMd(scope.row)">{{ $t('app_edit') }}</el-button>
					<label class="opbline">|</label>
					<el-button @click="delRow(scope.row.productkey)" type="text" class="opdcolor">{{ $t('app_delete') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>

		<el-dialog class="gstdia" :title="isEdit? $t('model.edit_model') : $t('model.add_model')" :visible.sync="showDia" @close="closeDia">
			<el-form :model="aform" :rules="rules">
				<el-form-item label="productKey" :label-width="$formlbWidth">
					<el-input v-model="aform.key" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label="$t('model.app_model')" :label-width="$formlbWidth">
					<el-input v-model="aform.model" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item :label-width="$formlbWidth">
					<el-button @click="closeDia">{{ $t("app_cancel") }}</el-button>
					<el-button :disabled="addMdRqDis" type="primary" @click="makeRqs">{{ $t("app_sure") }}</el-button>
				</el-form-item>
			</el-form>
			<!-- <div slot="footer" class="dialog-footer">        
      </div>-->
		</el-dialog>
	</div>
</template>

<style>
</style>

<script>
	import Pages from "@/components/Pages.vue";
	export default {
		data() {
			return {
				pconfig: "",
				tableData: [],
				isEdit: false,
				showDia: false,
				aform: {
					item: "",
					oldKey: "",
					model: "",
					key: ""
				},
				optionsProType: [{
						TypeName: this.$t('model.self_tube'),
						productType: "0"
					},
					{
						TypeName: this.$t('model.other_manage'),
						productType: "1"
					}
				],
				page: 1,
				total: 0,
				loading: false
				//  rules: {
				//   model: [
				//     { required: true, message: '请输入内容', trigger: 'blur' }
				//   ],
				//   productName: [
				//     { required: true, message: '请输入内容', trigger: 'blur' }
				//   ],
				//   productSecret: [
				//     { required: true, message: '请输入内容', trigger: 'blur' }
				//   ],
				//   productType: [
				//     { required: true, message: '请选择', trigger: 'blur' }
				//   ]
				// }
			};
		},
		components: {
			Pages
		},
		computed: {
			addMdRqDis() {
				var form = this.aform;
				if (form.model) {
					return false;
				} else {
					return true;
				}
			}
		},
		methods: {
			delRqs(id) {
				this.loading = true;
				this.$delModel(
					id,
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.getList();
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			},
			// batchDel () {
			//   var arr = []
			//   this.sRows.forEach(item => {
			//     arr.push(item.id)
			//   })
			//   this.delRow(arr.toString())
			// },
			delRow(aid) {
				this.$showMsgBox(
					this.$t('app_delete_question'),
					() => {
						this.delRqs(aid);
					},
					""
				);
			},

			closeDia() {
				this.showDia = false;
				this.aform.item = "";
				this.aform.oldKey = "";
				this.aform.model = "";
				this.aform.key = "";
			},
			makeRqs() {
				this.loading = true;
				if (this.isEdit) {
					var fm = this.aform;
					this.$editModel(
						fm.oldKey,
						fm.key,
						fm.model,
						res => {
							this.loading = false;
							if (res.status == 200) {
								this.closeDia();
								this.getList();
							} else {
								this.$message.error(res.message);
							}
						},
						() => {
							this.loading = false;
						}
					);
				} else {
					this.$addModel(
						this.aform.key,
						this.aform.model,
						res => {
							this.loading = false;
							if (res.status == 200) {
								this.closeDia();
								this.getList();
							} else {
								this.$message.error(res.message);
							}
						},
						() => {
							this.loading = false;
						}
					);
				}
			},
			addMd() {
				this.isEdit = false;
				this.showDia = true;
			},
			editMd(row) {
				this.isEdit = true;
				this.aform.item = row;
				this.aform.model = row.productname;
				this.aform.key = row.productkey;
				this.aform.oldKey = row.productkey;
				this.showDia = true;
			},
			getList() {
				this.loading = true;
				var modelId = "";
				this.$models(
					this.page,
					this.$gRow,
					modelId,
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.total = res.total;
							this.tableData = res.data;
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			}
			// batchSelected (val) {
			//   this.sRows = val
			// }
		},
		mounted() {
			this.getList();
			var _this = this;
			this.pconfig = {
				callback: page => {
					///
					_this.page = page;
					_this.getList();
				}
			};
		}
	};
</script>
